export const COLLECTION_ITEM_TYPES = {
    COLLECTION_TITLE: 'COLLECTION_TITLE',
    COLLECTION_SUBTITLE: 'COLLECTION_SUBTITLE',
    COLLECTION_IMAGE_CAPTION: 'COLLECTION_IMAGE_CAPTION',
    COLLECTION_QNA: 'COLLECTION_QNA',
    COLLECTION_WISHLIST: 'COLLECTION_WISHLIST',
    COLLECTION_SECTION_TITLE: 'COLLECTION_SECTION_TITLE',
    COLLECTION_QUOTE: 'COLLECTION_QUOTE',
    COLLECTION_INTRO_CONTENT: 'COLLECTION_INTRO_CONTENT',
    COLLECTION_SPOTIFY_EMBED: 'COLLECTION_SPOTIFY_EMBED',
};
